import { render, staticRenderFns } from "./FormResultsList.vue?vue&type=template&id=04fdecfc"
import script from "./FormResultsList.vue?vue&type=script&lang=js"
export * from "./FormResultsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports